<template>
    <div>
        <slot :manual-link="manualLink"></slot>
    </div>
</template>

<script>
import {tenantKey} from '@shared/utils/tenant';

// custom apps/hyundai-v2 로컬 Faq 의 2026 사업장 평가 플랫폼 매뉴얼(KOR/ENG/CHN) 이관 (2026-09-03).
// hyundai-2025 테넌트(구 apps/hyundai 동결 빌드)는 같은 legacyCustomEnv('hyundai')를 쓰므로 여기서 연도만 분기.
const MANUALS = {
    hyundai: {
        ko: '/document/manual/hyundai/2026_현대차_사업장_평가_플랫폼_사용_매뉴얼_(KOR).pdf',
        en: '/document/manual/hyundai/2026_Hyundai_Motor_Business_Site_Assessment_Platform_User_Manual_(ENG).pdf',
        ca: '/document/manual/hyundai/2026_现代汽车_法人ESG评价_评价平台用户手册_(CHN).pdf',
    },
    'hyundai-2025': {
        ko: '/document/manual/hyundai-2025/2025_현대차_사업장_평가_플랫폼_사용_매뉴얼_(KOR).pdf',
        en: '/document/manual/hyundai-2025/2025_Hyundai_Motor_Business_Site_ESG_Assessment_Platform_Manual_(ENG).pdf',
        ca: '/document/manual/hyundai-2025/2025_现代汽车法人ESG评价_评价平台用户手册_(CHN).pdf',
    },
};

export default {
    name: 'HyundaiManual',
    computed: {
        manualLink() {
            const set = MANUALS[tenantKey] || MANUALS.hyundai;
            return set[this.$i18n.locale] || set.ko;
        },
    },
};
</script>
